var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgViewable = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 8,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.895 6.151a13.28 13.28 0 0 0 1.447-1.25c.259-.258.442-.46.542-.581a.5.5 0 0 0 0-.64c-.1-.12-.283-.323-.542-.58a13.28 13.28 0 0 0-1.447-1.251C10.345.697 8.695 0 7 0 5.305 0 3.654.697 2.105 1.849a13.29 13.29 0 0 0-1.447 1.25 9.18 9.18 0 0 0-.542.581.5.5 0 0 0 0 .64c.1.12.283.323.542.58.427.427.912.853 1.447 1.251C3.655 7.303 5.305 8 7 8c1.695 0 3.346-.697 4.895-1.849ZM4 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
  fill: "#00BAC6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "#00BAC6"
})));
export { SvgViewable as ReactComponent };
export default __webpack_public_path__ + "48d495d764165c3969e732379d4227fa.svg";